import React from 'react';
import {IonIcon, IonText} from "@ionic/react";
import {briefcaseOutline, documentOutline, locationOutline} from "ionicons/icons";
import {callFunctionToDownload} from "../lib/downloadHelper";

export default function MatrimonyProfileDetails({matrimonialProfileDetail}){
    const [imageArray, setImageArray] = React.useState([]);
    const [previewIndex, setPreviewIndex] = React.useState(null);

    React.useEffect(()=>{
        if(matrimonialProfileDetail && matrimonialProfileDetail.image_url?.length){
            let imageList = JSON.parse(matrimonialProfileDetail.image_url);
            setImageArray(imageList)
        }
    },[matrimonialProfileDetail])

    const handleImageClick = (index) => {
        setPreviewIndex(index);
    };

    const closePreview = () => setPreviewIndex(null);

    const nextImage = () => {
        setPreviewIndex((prev) => (prev + 1) % imageArray.length);
    }

    const prevImage = () => {
        setPreviewIndex((prev) => (prev - 1 + imageArray.length) % imageArray.length);
    }

    return (
        <div className="job_detail_common_page" data-publisher-content="true">
            {/* Basic Job Info */}
            <div className="matrimony-card">
                <div className="matrimony-card-img-cont">
                    <img
                        src={
                            (Array.isArray(matrimonialProfileDetail.image_url)
                                    ? matrimonialProfileDetail.image_url
                                    : JSON.parse(matrimonialProfileDetail.image_url || "[]")
                            )[0]
                        }
                        alt={matrimonialProfileDetail.name}
                        className="matrimony-card-img"
                    />
                </div>

                <div className="matrimony-card-info">
                    <h3 className="matrimony-card-name">{matrimonialProfileDetail.name}</h3>
                    <p className="matrimony-card-details">
                        {matrimonialProfileDetail.age} yrs | {matrimonialProfileDetail.height} | {matrimonialProfileDetail.religion}, {matrimonialProfileDetail.caste}
                    </p>
                    <p className="matrimony-card-occupation">
                        <IonIcon icon={briefcaseOutline}/> {matrimonialProfileDetail.occupation}
                    </p>
                    <p className="matrimony-card-location">
                        <IonIcon icon={locationOutline}/> {matrimonialProfileDetail.location}
                    </p>
                </div>
            </div>
            {/* Job Description */}
            <div className="job-description">
                <IonText><h6>About Me</h6></IonText>
                <p>{matrimonialProfileDetail?.about_me}</p>
            </div>
            <div className="job-key-responsiblities">
                <IonText><h6>Family Details:</h6></IonText>
                <ul>
                    <li>Father: {matrimonialProfileDetail?.father_occupation}</li>
                    <li>Mother: {matrimonialProfileDetail?.mother_occupation}</li>
                    <li>Siblings: {matrimonialProfileDetail?.siblings}</li>
                </ul>
            </div>

            {/*/// IMAGE GALLERY SECTION ///*/}
            <div className="job-key-responsiblities matrimony-images-section">
                <IonText>
                    <h6>Gallery</h6>
                </IonText>
                <div className="image-preview-container">
                    {imageArray.length ?
                        imageArray.slice(0, 3).map((img, index) => (
                        <div key={index} className="preview-image-wrapper" onClick={() => handleImageClick(index)}>
                            <img src={img} alt={`preview-${index}`} className="preview-image" />
                            {index === 2 && imageArray.length > 3 && (
                                <div className="more-overlay">+{imageArray.length - 3}</div>
                            )}
                        </div>
                    )) : "No Image"}
                </div>
            </div>
            {/*/// IMAGE GALLERY SECTION ///*/}

            {/*/// Lightbox Preview Overlay ///*/}
            {previewIndex !== null && (
                <div className="matrimonial-lightbox-overlay">
                    <span className="close-btn" onClick={closePreview}> ✕</span>
                    {previewIndex > 0 ? <button className="nav-btn left" onClick={prevImage}>‹</button> : ''}
                    <img
                        src={imageArray[previewIndex]}
                        alt="full-preview"
                        className="lightbox-img"
                    />
                    {previewIndex < imageArray.length - 1 && (
                        <button className="nav-btn right" onClick={nextImage}>›</button>
                    )}
                </div>
            )}
            {/*/// Lightbox Preview Overlay ///*/}

            <div className="job-key-responsiblities">
                <IonText><h6>Complete Bio Data Pdf:</h6></IonText>
                <ul>
                    <li>
                        {matrimonialProfileDetail.pdf_url ? (
                            <>
                                <IonIcon icon={documentOutline}/>{" "}
                                <a onClick={()=>callFunctionToDownload(matrimonialProfileDetail.pdf_url)} rel="noopener noreferrer">
                                    Download PDF
                                </a>
                            </>
                        ) : (
                            "No attachment"
                        )}
                    </li>
                </ul>
            </div>
            <div className="job-requirement">
                <IonText><h6>Partner Preferences:</h6></IonText>
                <ul>
                    <li>Age: {matrimonialProfileDetail?.partner_age} years</li>
                    <li>Religion/Caste: {matrimonialProfileDetail?.partner_religion}</li>
                    <li>Education: {matrimonialProfileDetail?.partner_education}</li>
                    <li>Location: {matrimonialProfileDetail?.partner_location}</li>
                </ul>
            </div>
        </div>
    )
}